export default __webpack_public_path__ + "static/6---Interview-Questions-to-Ask-While-Hiring-a-UX-Designer-88a54e553e8b7c416b223b1c43e88763.png";